/**
 * useIsNarrowViewport — detect when viewport is ≤ 1024px (mobile-first breakpoint).
 *
 * Uses matchMedia('(max-width: 1024px)') with a change event listener, not a raw
 * resize listener, for better performance. Returns boolean, updates on viewport change.
 *
 * Usage:
 *   const isNarrow = useIsNarrowViewport();
 *   // use isNarrow to render mobile drawer
 */
import { useState, useEffect } from 'react';

export function useIsNarrowViewport(): boolean {
  const [isNarrow, setIsNarrow] = useState<boolean>(() => {
    if (typeof window === 'undefined') return false;
    return window.matchMedia('(max-width: 1024px)').matches;
  });

  useEffect(() => {
    const mq = window.matchMedia('(max-width: 1024px)');

    const handleChange = (e: MediaQueryListEvent): void => {
      setIsNarrow(e.matches);
    };

    mq.addEventListener('change', handleChange);
    return () => mq.removeEventListener('change', handleChange);
  }, []);

  return isNarrow;
}
